module.exports = {
      id: "comm-health-usage",
      viewBox: "0 0 321.539 50.773",
      url: "/" + "sprite-0c9f646beffa24bb04e01488ef4c0ff4.svg#comm-health",
      toString: function () {
        return this.url;
      }
    }